import {AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ControlprocedureApiService} from '../../../../projects/api/src/controlprocedure/controlprocedure-api.service';

@Component({
  selector: 'app-border-tooltip',
  templateUrl: './border-tooltip.component.html',
  styleUrls: ['./border-tooltip.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class BorderTooltipComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {


  text = '';

  @Input() showLabel = true;
  @Input() procId: any;

  borders: any = {loading: true, data: []};
  isGeo = false;
  isFunc = false;

  constructor(private controlProcedureApiService: ControlprocedureApiService,
              private cdr: ChangeDetectorRef) {

  }


  ngOnChanges() {
    if (this.procId) {
      this.getBorders();
    }
    this.cdr.detectChanges();
  }

  ngOnInit() {
    return;
  }


  ngOnDestroy() {
    return;
  }

  ngAfterViewInit(): void {
    return;
  }

  getBorders() {
    this.borders = {loading: true, data: []};
    this.controlProcedureApiService.getProcedureBordersById(this.procId).subscribe(val => {
      this.borders = {loading: false, data: []};
      val.forEach(border => {
         if (border.type === 'FUNC') {
           this.isFunc = true;
         } else if (border.type === 'GEO') {
          this.isGeo = true;
        } else if (border.type === 'NUMERIC') {
          this.isGeo = false;
          border.intervals.forEach(interval => {
            this.borders.data.push({
              from: interval.from,
              to: interval.to,
              state: (border.state as any).sysState
            });
          });
        }
      });
      this.borders.data = this.borders.data.sort((a, b) => {
        if (a.from === null) { return -1; }
        if (b.from === null) { return +1; }
        return a.from - b.from;
      });
      this.cdr.detectChanges();
    });
  }
}



